"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parserBrowser = exports.loadMiniProgramSDK = exports.lineToHump = exports.isWindows = exports.isObject = exports.isMobile = exports.isInWechat = exports.isInApp = exports.isIOS = exports.isFunction = exports.historyPush = exports.firstUpperCase = exports.difference = exports.diffchange = exports.deepCopy = exports.addUuidToObj = void 0;
exports.runEffectivenessProps = runEffectivenessProps;
exports.serialId = serialId;
exports.uuid = exports.urlAllParams = exports.setValue = void 0;

var _blueimpMd = _interopRequireDefault(require("blueimp-md5"));

var _lodash = require("lodash");

var _excluded = ["nameMap", "formData", "cascaderList"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var root = {};

if (typeof window !== 'undefined') {
  root = window;
}

var UA = typeof window === 'undefined' ? '' : root.navigator.userAgent.toLowerCase(); // 移动端

var isMobile = /android|iphone|iPad|ipod|windows\sphone/.test(UA);
exports.isMobile = isMobile;
var isIOS = /iPhone|iPad|iPod/i.test(UA); // App内

exports.isIOS = isIOS;
var isInApp = !!~UA.indexOf('iyunbao'); // 是否为window系统

exports.isInApp = isInApp;
var isWindows = /windows|win32/.test(UA); // 微信

exports.isWindows = isWindows;
var isInWechat = !!~UA.indexOf('micromessenger');
/**
 * 对象检测
 * @param value
 */

exports.isInWechat = isInWechat;

var isObject = function isObject(value) {
  return Reflect.toString.call(value) === '[object Object]';
};
/**
 * 函数检测
 * @param func
 */


exports.isObject = isObject;

var isFunction = function isFunction(func) {
  return typeof func === 'function';
};
/**
 * 比对数组，过滤values 值
 * @param array
 * @param values
 */


exports.isFunction = isFunction;

var difference = function difference(array, values) {
  if (!(array && Array.isArray(array) && array.length)) {
    return [];
  }

  if (!(values && Array.isArray(values) && values.length)) {
    return array;
  }

  var result = [];
  array.forEach(function (key) {
    if (values.indexOf(key) < 0) {
      result.push(key);
    }
  });
  return result;
};

exports.difference = difference;

var setValue = function setValue(obj, names, value) {
  (0, _lodash.set)(obj, names, value);
};

exports.setValue = setValue;
;
/**
 * 比对触发数据
 * @param {string[]} attrs 属性表
 * @param {object}   from  数据1
 * @param {object}   to    数据2
 */

var diffchange = function diffchange(attrs, from, to) {
  return attrs.some(function (key) {
    return from[key] !== to[key];
  });
};
/**
 * 深复制
 * @param {array|object} data 数据
 */


exports.diffchange = diffchange;

var deepCopy = function deepCopy(data) {
  return (0, _lodash.cloneDeep)(data);
};
/**
 * 获取URL全部参数
 * @param  {string} url  链接地址
 * @return {object}      返回参数值
 */


exports.deepCopy = deepCopy;

var urlAllParams = function urlAllParams(url) {
  if (!url) {
    url = window.location.href;
  } // Regex for replacing addition symbol with a space


  var pl = /\+/g;
  var urlParams = {};

  var decode = function decode(s) {
    return decodeURIComponent(s.replace(pl, ' '));
  };

  url = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (_m, key, value) {
    urlParams[decode(key)] = decode(value);
  });
  return urlParams;
};
/**
 * 生成随机串
 */


exports.urlAllParams = urlAllParams;

var uuid = function uuid() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;

  /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*** */
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = $chars.length;
  var pwd = '';

  for (var i = 0; i < len; i += 1) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
};

exports.uuid = uuid;

var addUuidToObj = function addUuidToObj(item) {
  if (isObject(item)) {
    if (!item.uuid) {
      item.uuid = uuid();
    }

    return item;
  }

  return {
    uuid: uuid()
  };
};
/**
 * 首字母转换大写
 * @param {string} str  内容
 */


exports.addUuidToObj = addUuidToObj;

var firstUpperCase = function firstUpperCase(str) {
  if (typeof str !== 'string') {
    return '';
  }

  return str.replace(/^\S/g, function (s) {
    return s.toUpperCase();
  });
};

exports.firstUpperCase = firstUpperCase;

function runEffectivenessProps(props) {
  if (isObject(props)) {
    var _props$nameMap = props.nameMap,
        nameMap = _props$nameMap === void 0 ? {} : _props$nameMap,
        _props$formData = props.formData,
        formData = _props$formData === void 0 ? {} : _props$formData,
        _props$cascaderList = props.cascaderList,
        cascaderList = _props$cascaderList === void 0 ? [] : _props$cascaderList,
        others = _objectWithoutProperties(props, _excluded);

    return _objectSpread({
      nameMap: isObject(nameMap) ? nameMap : {},
      formData: isObject(formData) ? formData : {},
      cascaderList: Array.isArray(cascaderList) ? cascaderList : []
    }, others);
  }

  return {
    nameMap: {},
    formData: {},
    cascaderList: []
  };
}
/**
 * 首字母转换大写
 * @param {string} str  内容
 */


var lineToHump = function lineToHump(str) {
  if (typeof str !== 'string') {
    return '';
  }

  return str.split('-').map(function (strItem) {
    return firstUpperCase(strItem);
  }).join('');
};
/**
 * 序列ID
 * @param {string} value     内容
 */


exports.lineToHump = lineToHump;

function serialId(value) {
  var hash = (0, _blueimpMd.default)(value);
  return hash ? hash.toString() : value;
}
/**
 * 加载小程序SDK
 * @param {function} cb  回调
 */


var loadMiniProgramSDK = function loadMiniProgramSDK(cb) {
  if (typeof root.wx === 'undefined') {
    var script = document.createElement('script');
    var head = document.getElementsByTagName('head')[0];
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js';

    script.onload = function () {
      script.onload = null;
      cb && cb();
    };

    head.appendChild(script);
  } else {
    cb && cb();
  }
};
/**
 * 页面无刷新跳转链接
 * @param {string}  url   跳转地址
 */


exports.loadMiniProgramSDK = loadMiniProgramSDK;

var historyPush = function historyPush(url) {
  var _root$location = root.location,
      pathname = _root$location.pathname,
      href = _root$location.href;
  /* eslint-disable no-useless-escape */

  var regOrigin = /^(https?\:\/\/)?([\.\w-]+)+(:[0-9]+)?/;
  var regUrl = /^(https?\:\/\/)?([\.\w-]+)+(:[0-9]+)?([\/\w-]*)?/; // 配置地址路径前

  var regexpPath = /\/[\w-]+\/[\w-]+/;

  if (!url) {
    console.error('history push not url');
    return false;
  } // 是否相对地址，如：/m/short/trial


  if (!regOrigin.test(url)) {
    root.location.href = url;
    return false;
  }

  var newUrl = url.split(regOrigin)[4]; // 域名地址相同
  // 跳转地址和当前地址不允许相同
  // 防止webpack多入口问题

  if (root.appHistory && root.appHistory.push && (url.match(regOrigin) || [])[0] === href.match(regOrigin)[0] && (url.match(regUrl) || [])[0] !== href.match(regUrl)[0] && (url.match(regexpPath) || [])[0] === pathname.match(regexpPath)[0] && newUrl) {
    try {
      root.appHistory.push(newUrl);
    } catch (error) {
      root.location.href = url;
    }
  } else {
    root.location.href = url;
  }
};
/**
 * 解析UA浏览器
 * @return {string}   返回浏览器
 * 浏览器 app(I云保App)、wechat(微信)、chrome、safari、other、wxapp(小程序)
 */


exports.historyPush = historyPush;

var parserBrowser = function parserBrowser() {
  var browser = 'other';

  switch (true) {
    // 微信
    case isInWechat:
      browser = 'wechat';
      break;
    // app内

    case isInApp:
      browser = 'app';
      break;
    // chrome

    case /chrome/.test(UA):
      browser = 'chrome';
      break;
    // safari

    case /safari/.test(UA):
      browser = 'safari';
      break;

    default:
  }

  return browser;
};

exports.parserBrowser = parserBrowser;